import { useState, useSyncExternalStore } from 'react';
/** Hosts key the owning component by owner/environment and provider session. */
export function useFundingResource(create) {
    const [store] = useState(() => {
        let resource = null;
        let subscriptions = 0;
        return {
            snapshot: () => resource,
            subscribe: (changed) => {
                subscriptions += 1;
                resource ??= create();
                changed();
                return () => {
                    subscriptions -= 1;
                    // React replays subscriptions synchronously in Strict Mode. Do not erase
                    // live provider credentials during that replay; real unmount still disposes.
                    queueMicrotask(() => {
                        if (subscriptions !== 0)
                            return;
                        resource?.dispose();
                        resource = null;
                    });
                };
            },
        };
    });
    return useSyncExternalStore(store.subscribe, store.snapshot, serverSnapshot);
}
function serverSnapshot() {
    return null;
}
